import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('leads-receptions-roulettes', storeModule.createStoreModule('leads-receptions-roulettes'))
